import React from "react";
import styles from "./ProcessingState.module.css";
import classnames from "classnames";

const ProcessingState = ({ className }) => {
  return (
    <div className={classnames(styles.root, className)}>
      <div>Queued for processing...</div>
    </div>
  );
};

export default ProcessingState;
